import api from './api';
import { handleApiError } from './financialService';

class ConfiguracoesFinanceiroService {
  constructor() {
    this.baseEndpoint = '/financeiro/configuracoes/';
  }

  // ========================================
  // CATEGORIAS
  // ========================================

  async getCategorias(tipo = null, ativa = null) {
    try {
      const params = {};
      if (tipo) params.tipo = tipo;
      if (ativa !== null) params.ativa = ativa;
      
      const response = await api.get(`${this.baseEndpoint}categorias`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar categorias');
    }
  }

  async getCategoriaById(id) {
    try {
      const response = await api.get(`${this.baseEndpoint}categorias/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar categoria');
    }
  }

  async createCategoria(data) {
    try {
      const response = await api.post(`${this.baseEndpoint}categorias`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao criar categoria');
    }
  }

  async updateCategoria(id, data) {
    try {
      const response = await api.put(`${this.baseEndpoint}categorias/${id}`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao atualizar categoria');
    }
  }

  async deleteCategoria(id, force = false) {
    try {
      const response = await api.delete(`${this.baseEndpoint}categorias/${id}`, {
        params: { force }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao deletar categoria');
    }
  }

  async reordenarCategorias(ordem) {
    try {
      const response = await api.put(`${this.baseEndpoint}categorias/reordenar`, ordem);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao reordenar categorias');
    }
  }

  async criarCategoriasPadrao() {
    try {
      const response = await api.post(`${this.baseEndpoint}categorias/criar-padroes`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao criar categorias padrão');
    }
  }

  // ========================================
  // ALERTAS
  // ========================================

  async getConfiguracoesAlertas() {
    try {
      const response = await api.get(`${this.baseEndpoint}alertas`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar configurações de alertas');
    }
  }

  async salvarConfiguracoesAlertas(data) {
    try {
      const response = await api.post(`${this.baseEndpoint}alertas`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao salvar configurações de alertas');
    }
  }

  async atualizarConfiguracoesAlertas(data) {
    try {
      const response = await api.put(`${this.baseEndpoint}alertas`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao atualizar configurações de alertas');
    }
  }

  // ========================================
  // MÉTODOS DE PAGAMENTO
  // ========================================

  async getMetodosPagamento() {
    try {
      const response = await api.get(`${this.baseEndpoint}metodos-pagamento`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar métodos de pagamento');
    }
  }

  async criarMetodosPadrao() {
    try {
      const response = await api.post(`${this.baseEndpoint}metodos-pagamento/criar-padroes`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao criar métodos padrão');
    }
  }

  // ========================================
  // ESTATÍSTICAS
  // ========================================

  async getEstatisticasUso() {
    try {
      const response = await api.get(`${this.baseEndpoint}estatisticas-uso`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar estatísticas de uso');
    }
  }
}

export default new ConfiguracoesFinanceiroService();
